import React from 'react'
import DigitalBooksListContainer from '../containers/digitalBooksListContainer'
import { digitalBooksLinks } from '../../utills/dititalBooksObject'

function DigitalBooks() {
  return (
    <div>
        <DigitalBooksListContainer data={digitalBooksLinks}/>
    </div>
  )
}

export default DigitalBooks